import { paths } from '@mc/paths'

type PathnameType = {
  isDark?: boolean
  hideCta?: boolean
}

export const getBannerPropsByPath = (pathname: string): PathnameType => {
  if (pathname.startsWith(paths.sessions())) {
    return { isDark: true, hideCta: false }
  }

  if (pathname === paths.checkout) {
    return { isDark: false, hideCta: true }
  }

  // pen-5108_v1 experiment
  if (pathname === paths.gift) {
    return { isDark: false, hideCta: true }
  }

  return { isDark: false, hideCta: false }
}
